import { Organization } from "@models/Organization";
import ListadoUsuarios from "@components/Configuracion/Usuarios/ListadoUsuarios";
import { TabDetailScreenWrapper } from "@components/General/TabDetailScreen";
import ListadoRoles from "@components/Configuracion/Usuarios/ListadoRoles";
import { useEffect, useState } from "react";
import { SingleTabScreen } from "@components/General/SingleTabScreen";
import ListadoPermisos from "@components/Configuracion/Usuarios/ListadoPermisos";
import { Role } from "@models/Permissions";
import { useLocation } from "react-router-dom";

interface ConfiguracionRolProps {
    org: Organization;
}


const ConfiguracionRol: React.FC<ConfiguracionRolProps> = ({org}) => {
    const [selectedRole, setSelectedRole] = useState<Role>(null);

    const location = useLocation();
    let role = location.state?.role;

    useEffect(() => {
        if (!role) return;
    
        setSelectedRole(role);    
    }, [role]);
    

    return (
        <SingleTabScreen
            title={"Rol " + (selectedRole ? selectedRole.name.localized() : '')}
            flap={{
                id: 'permisos',
                label: 'Permisos del rol',
                content: <ListadoPermisos org={org} role={role}/>,
            }}
            subtitle="Permisos del rol"
            hasBackButton={true}
        />
    );
}

export { ConfiguracionRol };